module.exports = "/images/vendor/flag-icon-css/flags/4x3/tr.svg?ed6d5f37779af38911b0b7cb2212e30d";